import { useRuntime } from "./useRuntime";
export var useLocale = function() {
    var ref = useRuntime(), locale = ref.locale, language = ref.language, market = ref.market;
    return {
        locale: locale,
        language: language,
        market: market
    };
};
